/**
 * Method that checks whether cls is present in element object.
 */
export const hasClass = (ele: HTMLElement, cls: string): boolean => {
  const elClass = ele.getAttribute('class');
  return Boolean(elClass && elClass.indexOf(cls) > -1);
};

/**
 * Method that adds a class to given element.
 */
export const addClass = (ele: HTMLElement, cls: string): void => {
  if (ele.classList) {
    ele.classList.add(cls);
  } else if (!hasClass(ele, cls)) {
    ele.setAttribute('class', `${ele.getAttribute('class')} ${cls}`);
  }
};

/**
 * Method that does a check to ensure that class is removed from element.
 */
export const removeClass = (ele: HTMLElement, cls: string): void => {
  if (ele.classList) {
    ele.classList.remove(cls);
  } else if (hasClass(ele, cls)) {
    const elClass = ele.getAttribute('class');
    if (!elClass) return;
    ele.setAttribute('class', elClass.replace(cls, ' '));
  }
};
